import { FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import ContactForm from "../forms/contactForm";
import CtaOffer from "../common/ctaOffer";

function Offer1KarczowanieDrzew() {
  return (
    <>
      {/* HERO */}
      <section className="relative overflow-x-hidden flex flex-col lg:flex-row items-center justify-between lg:min-h-[60vh] p-6 lg:px-12 lg:pt-48 lg:pb-36 gap-6">
        <img
          className="absolute w-full h-full object-cover z-10 top-0 left-0"
          src="https://magazyn.drzewus.pl/wp-content/uploads/2025/04/karczowanie-1.jpeg"
          alt="Karczowanie drzew - usuwanie krzewów i drzew - Drzewus"
        />
        <div className="w-full h-full object-cover z-20 absolute top-0 left-0 gradient-green-ltr"></div>
        <div className="flex flex-col items-start justify-center gap-2 z-30">
          <h1 className="text-3xl lg:text-6xl text-white text-left">
            Karczowanie działek pod budowę i usuwanie korzeni Gdańsk, Kartuzy
          </h1>
          <h2 className="text-xl lg:text-3xl text-white text-left">
            Kompleksowe oczyszczanie terenu z drzew i pni na Kaszubach
          </h2>
          <p className="text-white text-base lg:text-xl max-w-[850px] text-left">
            Karczowanie działek to kluczowy pierwszy etap przygotowania terenu pod nową inwestycję budowlaną na terenie Gdańska, Gdyni, Wejherowa i całych Kaszub. Nasza ekipa usuwa drzewa, krzewy, systemy korzeniowe oraz karpy przy użyciu ciężkiego sprzętu i minikoparek. Profesjonalne karczowanie łączymy z <a href="/oczyszczanie-terenu/mulczer-lesny" className="underline hover:opacity-80">mulczowaniem terenu</a> oraz <a href="/oczyszczanie-terenu/niewelacja-terenu" className="underline hover:opacity-80">niwelacją gruntu</a>, oddając Ci idealnie czystą działkę gotową pod fundamenty.
          </p>
          <a href="#wiecej">
            <button className="button-yellow">Dowiedz się więcej</button>
          </a>
        </div>
        <div className="z-30 max-w-[500px] flex flex-col items-center justify-center">
          {" "}
          <ContactForm />
        </div>
      </section>
      {/* CONTENT */}
      <section
        id="wiecej"
        className="p-6 lg:px-24 lg:py-12 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-12"
      >
        <div className="lg:col-span-1 flex flex-col gap-6">
          <div className="flex flex-col gap-2 p-6 rounded-xl bg-green w-full">
            <a
              href="#1"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Usuwanie pni drzew
            </a>
            <a
              href="#2"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Czym różni się karczowanie drzew na działce od wycinki?
            </a>
            <a
              href="#3"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Karczowanie drzew a pozwolenie na wycinkę
            </a>
            <a
              href="#4"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Skuteczne usuwanie pni drzew wraz z korzeniami
            </a>
            <a
              href="#5"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Karczowanie pni po wycince drzew
            </a>
            <a
              href="#6"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Z nami raz na zawsze usuniesz korzenie drzew i krzewów
            </a>
            <a
              href="#7"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Karczowanie drzew i krzewów - cennik
            </a>
            <a
              href="#8"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Chcesz mieć szybką wycenę?
            </a>
          </div>
          <CtaOffer />
        </div>
        <div className="lg:col-span-2 flex flex-col items-start justify-start text-left gap-2 content-offer">
          <h2 id="1">Usuwanie pni drzew</h2>
          <p>
            Oferujemy usługę karczowania drzew, lasu, zarośli itp. Możemy
            zarówno wyciąć drzewa, jak i usunąć pozostałe po tym pniaki wraz z
            ich systemem korzeniowym.
          </p>
          <p>
            Dlatego jeśli zastanawiasz się jak usunąć pień po ściętym drzewie,
            to jesteś w dobrym miejscu. Usuwanie korzeni to najlepszy sposób,
            żeby przygotować działkę pod inwestycję czy założenie ogrodu.{" "}
          </p>
          <p>
            Zlecając nam taką usługę zyskasz równą i płaską działkę. Jesteśmy w
            stanie przyciąć, wyciąć lub usunąć z korzeniami praktycznie każde
            drzewo.{" "}
            <strong>
              Poradzimy sobie nawet z najtrudniejszymi przypadkami.
            </strong>
          </p>
          <p>
            Zajmujemy się wycinką i karczowaniem drzew zarówno zdrowych, jak i
            chorych, uszkodzonych, w tym również wiatrołomów. Usuwamy też drzewa
            zagrażające Twojemu mieniu lub ludziom i to niezależnie od ich
            usytuowania czy charakteru cięć.
          </p>
          <h2 id="2">
            Czym różni się karczowanie drzew na działce od wycinki?
          </h2>
          <p>
            Różnica pomiędzy karczowaniem a wycinką drzewa dotyczy korzeni.
            Zwykła wycinka drzew to usunięcie jedynie nadziemnej części drzewa.
            W ziemi pozostaje pień razem z korzeniami, który może później
            przeszkadzać w użytkowaniu działki. Co prawda dostępne jest
            frezowanie pni, ale tylko{" "}
            <strong>
              karczowanie zapewnia trwałe pozbycie się pnia oraz korzeni
            </strong>
            .
          </p>
          <p>
            Frezowanie sprawdzi się wszędzie tam, gdzie niewskazane jest
            używanie ciężkiego sprzętu, który pojawi się przy karczowaniu. Więc
            <strong>
              jeśli masz zadbany trawnik czy ogród i nie chcesz, żeby jeździła
              po nim koparka, to wybierz frezowanie
            </strong>
            . To rozwiązanie jest też polecane jeśli nie będziesz już nic
            budował na działce. Wtedy wystarczy pozbyć się pniaka przez
            frezowanie, co jest szybsze od karczowania.
          </p>
          <p>
            Karczowanie to usunięcie pozostałości po wcześniejszej wycince albo
            <strong>
              kompleksowa usługa polegająca na wycince drzewa wraz z jego
              systemem korzeniowym
            </strong>
            . Dzięki temu teren przygotowany jest do zagospodarowania, a po
            drzewach, pniach i korzeniach nie będzie żadnego śladu.
          </p>
          <h3 id="3">Karczowanie drzew a pozwolenie na wycinkę</h3>
          <p>
            Jeśli chcesz pozbyć się drzewa, ale nie wiesz jak uzyskać pozwolenie
            na wycinkę, to możemy Ci w tym pomóc. Dokładnie znamy procedury
            związane z usuwaniem drzew. Zleć nam to zadanie. Dzięki temu
            zaoszczędzisz sobie nerwów na bieganie po urzędach. Zrobimy to za
            Ciebie.
          </p>
          <p>
            Jeśli cenisz sobie swój czas, to pozwól nam wyręczyć Cię w uzyskaniu
            pozwolenia na wycinkę. Załatwimy za Ciebie całą papierologię.
          </p>
          <p>
            Może się zdarzyć, że do wycinki drzewa będzie potrzebna ekspertyza
            dendrologiczna. Obejmuje ona ocenę stanu zdrowotnego zarówno całego
            drzewa, jak i pnia, analizę statyki drzewa oraz ryzyko wystąpienia
            zagrożenia dla ludzi i mienia, co może być główną podstawą do
            wycinki. W naszym zespole mamy doświadczonych fachowców, którzy w
            razie potrzeby przygotują taki dokument.
          </p>
          <h3 id="4">Skuteczne usuwanie pni drzew wraz z korzeniami</h3>
          <p>
            Usunięcie pni i korzeni wymaga odpowiedniego sprzętu. Do wyrywania
            pni wraz z korzeniami w zależności od potrzeby{" "}
            <strong>używamy minikoparki</strong>, a przy dużych pniakach
            <strong>standardowej koparki</strong>, która poradzi sobie nawet z
            dużymi pozostałościami po drzewach.
          </p>
          <p>
            Nasz sprzęt otrząsa ziemię z wyrwanych korzeni, która następnie
            trafi z powrotem do wykopu po usuwanym pniaku. Nie musisz się też
            martwić, co zrobić z wyrwanym pniem czy korzeniami. Wszystkie
            pozostałości zarówno po wycince, jak i po karczowaniu możemy bez
            problemu wywieźć z Twojej działki.
          </p>
          <p>
            Jest to jedyny sposób nie tylko na usunięcie pnia, ale też na
            pozbycie się korzeni, które w zależności od gatunku drzewa mogą
            zajmować spory obszar działki. Tylko w ten sposób można przygotować
            teren pod przyszłe inwestycje, dzięki czemu Twój ogród lub działka
            zyska zupełnie nowy wygląd.
          </p>
          <p>
            Po karczowaniu możemy od razu wykonać niwelację działki. Wykorzystaj
            to, że nasza ekipa jest już na miejscu i zleć nam dodatkowe prace.{" "}
          </p>
          <h3 id="5">Karczowanie pni po wycince drzew</h3>
          <p>
            Jeśli nie wiesz jak poradzić sobie z usunięciem pozostałości po
            wycince drzew, to zgłoś się do nas. Szybko{" "}
            <strong>
              rozprawimy się z pozostałościami po wyciętych drzewach
            </strong>
            . Dotyczy to zarówno korzeni i pniaków. To sprawi, że Twoja działka
            będzie przygotowana pod inwestycje budowlane.
          </p>
          <p>
            Dotyczy to szczególnie miejsc, w których będą wykonywane wykopy pod
            fundamenty. Ilość korzeni, które pozostają w ziemi po wyciętym
            drzewie może Cię zaskoczyć. Dlatego zamiast samodzielnie męczyć się
            podczas usuwania korzeni drzew oraz narażać się na zakwasy i
            odciski,{" "}
            <strong>
              zleć to zadanie profesjonalistom, którzy w swej karierze powalili
              już ogromne ilości drzew
            </strong>
            . Dzięki temu zaoszczędzisz sporo czasu, bo nie zmarnujesz wielu
            godzin czy nawet dni przy samodzielnym wykopywaniu pnia z
            korzeniami. Oszczędzisz też sobie nerwów, które na pewno pojawiają
            się wtedy, gdy robota nie idzie tak, jakby się chciało.
          </p>
          <p>
            Jeśli przygotowujesz działkę do sprzedaży, to najlepiej usunąć z
            niej wszystkie pniaki wraz z systemem korzeniowym pozostałe po
            wycince drzew. Dzięki temu zyska ona o wiele lepszy wygląd, a Ty
            uzyskasz lepszą cenę za swoją ziemię. Inwestorzy docenią równy teren
            bez żadnych niespodzianek w postaci pniaków, które mogą utrudniać
            przyszłą budowę, bo wymagają interwencji ciężkiego sprzętu.
          </p>
          <h4 id="6">Z nami raz na zawsze usuniesz korzenie drzew i krzewów</h4>
          <p>
            Z nami szybko i sprawnie{" "}
            <strong>
              pozbędziesz się fragmentów drzew, które zostały po wycince
            </strong>
            . Zlikwidujemy nie tylko całe drzewa. Wykopiemy też pozostałości po
            nich – karpy oraz korzenie.
          </p>
          <p>
            Dla nas nie ma znaczenia czy są to pozostałości dużych, czy małych
            drzew. Nie ważny jest też wiek drzewa lub krzewu. Nawet jeśli pniak
            jest sporych rozmiarów, a podziemny system korzeniowy dość rozległy,
            to i tak jesteśmy w stanie podjąć się takiego zlecenia.
          </p>
          <p>
            Działamy zarówno w okolicach Trójmiasta, jak i na terenie całego
            województwa pomorskiego. Dlatego jeśli interesuje Cię karczowanie
            drzew w Gdańsku, Wejherowie, Kartuzach lub w ich okolicach, to zgłoś
            się do nas. Otrzymasz indywidualną wycenę. Uzgodnimy też z Tobą
            termin i zakres niezbędnych prac.
          </p>
          <h2 id="7">Karczowanie drzew i krzewów - cennik</h2>
          <p>
            Cena za karczowanie pni może się różnić w zależności od wielkości
            pnia, rozległości systemu korzeniowego czy ukształtowania terenu.
            Dlatego jeśli chcesz poznać cenę karczowania drzew, to{" "}
            <strong>wypełnij formularz kontaktowy</strong>, a odezwiemy się do
            Ciebie tak szybko, jak to tylko możliwe.
          </p>
          <p>
            Świadczymy pełen wachlarz usług związanych z zakładaniem ogrodu,
            wycinką drzew czy pracami ziemnymi. Dzięki temu nie stracisz czasu
            na szukanie sprawdzonej ekipy do różnych rodzajów prac.
          </p>
          <p>
            Zamawiając wszystko w naszej firmie zaoszczędzisz też na kosztach
            dojazdu sprzętu, bo wszystkie urządzenia niezbędne do wykonania prac
            przywieziemy za jednym razem. Powiedz nam czego potrzebujesz, a{" "}
            <strong>przygotujemy dla Ciebie indywidualną ofertę</strong>.
          </p>
          <p>
            Nasze usługi skierowane są zarówno do klientów indywidualnych,
            instytucjonalnych, jak i biznesowych. Do każdego zlecenia
            podchodzimy z pełnym zaangażowaniem. Współpracując z nami docenisz
            naszą rzetelność i profesjonalizm.
          </p>
          <h5 id="8">Chcesz mieć szybką wycenę?</h5>
          <p>
            Gdy masz do wykarczowania całe drzewo, to podaj nam jego obwód oraz
            ewentualnie szacunkową wysokość. Jeśli masz zdjęcia drzewa do
            wycięcia, to również możesz je nam podesłać. Nie jest to konieczne,
            ale pozwoli nam lepiej oszacować wielkość drzewa.
          </p>
          <p>
            A gdy masz pniak do usunięcia, to podaj nam jego obwód, a jak
            chcesz, to możesz dołączyć też zdjęcie.{" "}
          </p>
          <p>
            Jeśli przekażesz nam dokładną lokalizację, na przykład za pomocą
            pinezki, to bardzo ułatwi nam to pracę i przyśpieszy wycenę. Jednak
            nie jest to niezbędnie konieczne.
          </p>
          <p>
            Po prostu podaj nam potrzebne dane, a otrzymasz od nas wycenę bez
            żadnych zobowiązań.
          </p>
        </div>
      </section>
      {/* PORTFOLIO */}
      <section className="p-6 lg:px-24 lg:py-12 flex flex-col gap-6">
        <div className="flex flex-col items-center justify-center mb-6">
          <h2 className="uppercase color-yellow text-xl text-center">
            Nasze realizacje
          </h2>
          <h3 className="text-3xl lg:text-5xl color-green text-center">
            Spójrz jak pomogliśmy<br></br>
            <span className="color-yellow">naszym Klientom</span>
          </h3>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/04/karczowanie-2.jpeg"
              alt="Karczowanie drzew - realizacja Drzewus nr 1"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/04/karczowanie-3.jpeg"
              alt="Karczowanie drzew - realizacja Drzewus nr 2"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/04/karczowanie-4-1.jpeg"
              alt="Karczowanie drzew - realizacja Drzewus nr 3"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/06/AdobeStock_677746581-2-scaled.jpeg"
              alt="Karczowanie - usunięte pnie i korzenie drzew"
              className="h-full object-cover w-full"
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default Offer1KarczowanieDrzew;
